export enum QueueItemProcess {
    FILEPATH_REMOVED = 'FILEPATH_REMOVED',
}
